import { Component, Input } from '@angular/core';
import { SplitStringsPipe } from '@app/pipes/text-separator/text-separator.pipe';
import { RedirectService } from '@app/services';
import { ProjectV2 } from '@interfaces/app';

@Component({
  selector: 'mnf-pi-v2-opp-documents',
  standalone: true,
  imports: [SplitStringsPipe],
  templateUrl: './pi-v2-opp-documents.component.html',
  styleUrl: './pi-v2-opp-documents.component.scss'
})
export class PiV2OppDocumentsComponent {

  @Input() campaignDocuments: string[];

  constructor(private redirectService: RedirectService) {}

  openLink(url: string) {
    this.redirectService.openURL(url);
  }

}
